import React, { useEffect, useState } from "react";
import AppStore from "../../../config/AppStore";
import {
  sendRequestGetPrepingReportsAdmin,
} from "../../../view_logics/Reports/Reports";
import _ from "lodash";
import Spinner from "../../../components/common/Spinner";
import PrepingReportFilter from "./PrepingReportFilter";
import PrepingReportDetails from "./PrepingReportDetails";
import { format } from "date-fns";

const PrepingReportList = () => {
  let store = AppStore.getAppStoreInstance();
  const [reportsList, setReportsList] = useState([]);
  const [prepingData, setPrepingData] = useState([]);
  const [prepingDetailId, setprepingDetailId] = useState();

  const [reportsFilterLoading, setReportsFilterLoading] = useState(false);

  const [filters, setFilters] = useState({
    "email": '',
    "from": new Date(),
    "to": new Date(),
    "advertiserId": '',
    "offerId":'',
  });

  const formatDate = (date) => format(date, "yyyy-MM-dd");

  const fetchPrepingData = async (postData) => {
    try {
      setReportsFilterLoading(true);
      const inputObj = {
        accessToken: store.getState().login.accessToken,
        url: "reports",
        data: postData,
        loadingHandler: setReportsFilterLoading,
        dataHander: setPrepingData,
      };
      const response = await sendRequestGetPrepingReportsAdmin(inputObj);
      setReportsFilterLoading(false);
      if (response) {
        setReportsList(response);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };


  useEffect(() => {
    const initialPostData = {
      "email": '',
      "from": formatDate(new Date()),
      "to": formatDate(new Date()),
      "advertiserId": '',
      "offerId":'',
    };
    fetchPrepingData(initialPostData);
  }, []);

  const handleFilterChange = (newFilters) => {
    console.log("filter data", formatDate(newFilters.to));
    const filterPostData = {
      "email": newFilters.email?newFilters.email:'',
      "from": formatDate(newFilters.from),
      "to": formatDate(newFilters.to),
      "advertiserId": newFilters.advertiserId?newFilters.advertiserId:'',
      "offerId": newFilters.offerId?newFilters.offerId:'',
    };
    fetchPrepingData(filterPostData);
    setFilters(newFilters); // Triggers useEffect
  };

  return (
    <>
      <PrepingReportDetails prepingId={prepingDetailId} filters={filters} isVisible='true' />

      <div className="col-12 col-xl-12 position-relative">
        <div className="card">
          <PrepingReportFilter filters={filters} onFilterChange={handleFilterChange} />
          <table id="reports" className="table table-striped">
            <thead>
              <tr>
                <th scope="col">ID</th>
                <th scope="col">Offer</th>
                <th scope="col">Adv ID</th>
                <th scope="col">Advertiser</th>
                <th scope="col">Preping</th>
              </tr>
            </thead>
            <tbody>
              {prepingData?.length > 0 ? (
                prepingData?.map((report, index) => {
                  return (
                    <React.Fragment key={index}>
                      <tr className="table-info">
                        <td>{report.id}</td>
                        <td>{report.offer_name}</td>
                        <td>{report.advertiser_name}</td>
                        <td>{report.advertiser_id}</td>
                        <td><a
                          onClick={() => setprepingDetailId(report.offer_id)}
                          Style="color:#3c8dbc" data-bs-toggle="modal" data-bs-target="#preping_details_report_model">{report.pre_pings}</a></td>
                      </tr>
                    </React.Fragment>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="12">No records found …</td>
                </tr>
              )}
            </tbody>
            {reportsFilterLoading && <Spinner />}
          </table>
          <hr />
          {/* <PaginationComponent /> */}
        </div>
        {/* {apiData == null && <Spinner/>} */}
      </div>
    </>
  );
};
export default PrepingReportList;
